import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "toast"
};
import { computed, onMounted, watch, onBeforeMount } from 'vue';
import { RouterView } from 'vue-router';
import { DEVICE_NAME_MAP, MAX_DEVICE_ONLINE_NUM, STAND_AUTH_PROCESS_PATH_ENV } from '@remote/constant';
import Dialog from '@remote/components/Dialog.vue';
import Header from '@remote/components/HeaderPlus.vue';
import HuddlePop from '@remote/components/HuddlePop.vue';
import FooterBar from '@remote/components/FooterBar.vue';
import FilePop from '@remote/components/FilePop.vue';
/* import ReloadPrompt from '@remote/components/ReloadPrompt.vue' */
import { getLocalValue, isInXunleiApp, nativeCall, newToast, setLocalValue, stringifySearch } from '@remote/utils';
import global from '@remote/store/constantStore';
import { useAuth } from '@remote/composable/auth';
import sso, { getSSOUser, safeSSOInit } from '@remote/utils/sso';
import { useEnvStore } from '@remote/store/env';
import { isAndroidNative, isIOSNative, sendMessage } from '@xunlei/universal-native-api';
import { store } from '@remote/store';
import { stat } from '@remote/utils/stat';
import { flowHubInstance } from '@remote/api/flowhub';
import router from '@remote/router';
import { useHeziStore } from '@remote/store/hezi';
// import { safeJSONParse } from '@shared/utils'
import { useDeviceStore } from '@remote/store/device';
import { nextTick } from 'vue';
import { VipVasType, useUserStore } from '@remote/store/user';
import { openPopCinemaDetail, openCinemaSourceSetting, openDialogDeviceLimitExceeded, openDeviceList, openDialogCooperationExpires } from '@remote/utils/dialog';
import { useCooperation } from '@shared/composable/cooperation';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const envStore = useEnvStore();
    const dialog = computed(() => {
      return store.state.dialog;
    });
    const toast = computed(() => {
      return store.state.toast;
    });
    const action = computed(() => {
      return store.state.action;
    });
    const queryAuth = computed(() => {
      return {
        ...store.state.queryAuth,
        scope: envStore.scope
      };
    });
    const privilegeAuth = computed(() => {
      return store.state.privilegeAuth;
    });
    const isNative = computed(() => {
      return store.state.isNative;
    });
    const show = computed(() => {
      return dialog.value.show;
    });
    const showHead = computed(() => {
      return ['home', 'me', 'plugin', 'login'].includes(router.currentRoute.value.name);
    });
    const deviceStore = useDeviceStore();
    const target = computed(() => {
      var _deviceStore$currentD, _deviceStore$currentD2;
      return (_deviceStore$currentD = (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 || (_deviceStore$currentD2 = _deviceStore$currentD2.runnerTaskRef.params) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.target) !== null && _deviceStore$currentD !== void 0 ? _deviceStore$currentD : '';
    });
    const watchDeviceExceedLimit = () => {
      const watchStopHandler = watch(() => deviceStore.runnerList, newList => {
        // 判断是否需要展示设备数量超出限制弹窗
        if (store.state.fromSpace) {
          const t = newList.filter(task => task.phase === 'PHASE_TYPE_RUNNING').length;
          if (t >= MAX_DEVICE_ONLINE_NUM) {
            var _newList$find;
            // 超出数量限制时，runner不会创建，所以要么找不到相同space的runner，要么找得到runner但是phase不是running
            if (!(newList && ((_newList$find = newList.find(v => {
              var _v$params;
              return ((_v$params = v.params) === null || _v$params === void 0 ? void 0 : _v$params.target) === store.state.fromSpace;
            })) === null || _newList$find === void 0 ? void 0 : _newList$find.phase) === 'PHASE_TYPE_RUNNING')) {
              stat({
                action: 'reconnect_device_page_show',
                data: {
                  errorcode: 'over_limit_num'
                }
              });
              store.commit('update', {
                showLoader: false
              });
              watchStopHandler(); // 停止监听
              openDialogDeviceLimitExceeded({});
              return;
            }
          }
        }
      });
    };
    const filterDevice = deviceMap => {
      let toBeFilter = Array.from(deviceMap);
      // 在PC中时，要过滤掉自己。
      if (envStore.isInPC) {
        toBeFilter = toBeFilter.filter(i => {
          var _i$;
          return ((_i$ = i[1]) === null || _i$ === void 0 || (_i$ = _i$.runnerTaskRef) === null || _i$ === void 0 || (_i$ = _i$.params) === null || _i$ === void 0 ? void 0 : _i$.platform) !== 'pcxllite';
        });
      }
      // 不在海康环境中时要过滤掉海康设备
      // if (platformPath !== 'hik') {
      //   toBeFilter = toBeFilter.filter(i => i[1]?.runnerTaskRef?.params?.platform !== 'hiksemi')
      // }
      // 2024-11-04 绿联设备取消手雷中展示的限制
      // 不在绿联环境中时要过滤掉绿联设备
      // if (platformPath !== 'ugreen' && platformPath !== 'new-ugreen') {
      //   toBeFilter = toBeFilter.filter(i => i[1]?.runnerTaskRef?.params?.platform !== 'ugreen')
      // }
      return new Map(toBeFilter);
    };
    const watchRunnerUtilDeviceOnline = () => {
      // 创建一个watcher，监听deviceMap的变化，当有设备上线时，切换到该设备
      const unwatch = watch(deviceStore.deviceMap, newMap => {
        const filteredDeviceMap = filterDevice(newMap);
        for (const i of filteredDeviceMap) {
          if (i[1].runnerTaskRef.phase === 'PHASE_TYPE_RUNNING') {
            deviceStore.changeCurrentDevice(i[0]);
            unwatch();
            newToast({
              message: '检测到有设备上线，已自动切换到该设备'
            });
            break;
          }
        }
      }, {
        immediate: true
      });
    };
    /**
     * 选择默认设备
     * 在第一次调用deviceStore.pollRunnerList之后调用
     * 优先级P0: 使用url中指定的space
     * 优先级P1: 使用本地缓存，且该设备在线
     * 优先级P2: 取第一个在线设备
     * 优先级P3: 使用本地缓存，且该设备离线
     * 优先级P4(兜底): 使用第一个设备
     */
    const selectDefaultDeviceSpace = () => {
      var _cachedDeviceRunner$p, _filteredDeviceMap$ge;
      const cachedDeviceRunner = getLocalValue('curDeviceRunner');
      const cachedSpace = cachedDeviceRunner === null || cachedDeviceRunner === void 0 || (_cachedDeviceRunner$p = cachedDeviceRunner.params) === null || _cachedDeviceRunner$p === void 0 ? void 0 : _cachedDeviceRunner$p.target;
      const deviceMap = deviceStore.deviceMap;
      const filteredDeviceMap = filterDevice(deviceMap);
      // 优先级P0: 使用url中指定的space
      if (envStore.space) {
        console.log('[默认设备]使用url中指定的space', envStore.space);
        return envStore.space;
      }
      // 优先级P1: 使用本地缓存，且该设备在线
      if (cachedSpace && filteredDeviceMap.has(cachedSpace) && ((_filteredDeviceMap$ge = filteredDeviceMap.get(cachedSpace)) === null || _filteredDeviceMap$ge === void 0 ? void 0 : _filteredDeviceMap$ge.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING') {
        console.log('[默认设备]使用本地缓存(在线)', cachedSpace);
        return cachedSpace;
      }
      // 优先级P2: 取第一个在线设备
      for (const i of filteredDeviceMap) {
        if (i[1].runnerTaskRef.phase === 'PHASE_TYPE_RUNNING') {
          console.log('[默认设备]取第一个在线设备', i[0]);
          return i[0];
        }
      }
      // 此时已无在线设备
      // 优先级P3: 使用本地缓存，且该设备离线
      if (cachedSpace && filteredDeviceMap.has(cachedSpace)) {
        // 优先级P4: 取第一个设备(最近在线)
        // 使用本地缓存，且该设备已离线线
        console.log('[默认设备]使用本地缓存(离线)', cachedSpace);
        return cachedSpace;
      }
      // 优先级P4(兜底): 使用第一个设备
      watchRunnerUtilDeviceOnline();
      console.log('[默认设备]取第一个设备', filteredDeviceMap.keys().next().value);
      return filteredDeviceMap.keys().next().value;
    };
    // 兼容性：监听更新原来store里的curDeviceRunner
    watch(() => {
      var _deviceStore$currentD3;
      return (_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.runnerTaskRef;
    }, val => {
      var _val$params;
      store.commit('update', {
        checking: false,
        connecting: false,
        loading: false,
        space: val === null || val === void 0 || (_val$params = val.params) === null || _val$params === void 0 ? void 0 : _val$params.target,
        curDeviceRunner: val
      });
    });
    const {
      checkIsShowCooperationDialog
    } = useCooperation({
      getDeviceInfo: () => {
        var _deviceStore$currentD4, _deviceStore$currentD5;
        return (_deviceStore$currentD4 = (_deviceStore$currentD5 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD5 === void 0 ? void 0 : _deviceStore$currentD5.deviceInfoRef) !== null && _deviceStore$currentD4 !== void 0 ? _deviceStore$currentD4 : {};
      },
      openDialogCooperationExpires: openDialogCooperationExpires
    });
    // 兼容性：监听更新原来store里的deviceInfoWatchData
    watch(() => {
      var _deviceStore$currentD6;
      return (_deviceStore$currentD6 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD6 === void 0 ? void 0 : _deviceStore$currentD6.deviceInfoRef;
    }, val => {
      store.commit('update', {
        deviceInfoWatchData: val
      });
      checkIsShowCooperationDialog();
    });
    /**
     * 监听设备列表，如果没有在线设备，
     */
    watch(deviceStore.deviceMap, val => {
      if (Array.from(val.values()).every(i => i.runnerTaskRef.phase !== 'PHASE_TYPE_RUNNING')) {
        watchRunnerUtilDeviceOnline();
      }
    });
    const userStore = useUserStore();
    const bodyClass = computed(() => {
      var _router$currentRoute$, _deviceStore$currentD7;
      // 片库黑色
      if (['cinema', 'OAuthCallback', 'cinema-source'].includes((_router$currentRoute$ = router.currentRoute.value.name) !== null && _router$currentRoute$ !== void 0 ? _router$currentRoute$ : '')) {
        return 'is-dark';
      }
      // 除片库、下载、小工具、我的、登录以外，都是白色
      if (!['home', 'plugin', 'me', 'login'].includes(String(router.currentRoute.value.name))) {
        return 'is-menu';
      }
      const cacheIsVip = getLocalValue('isVip');
      if (!userStore.hasInit && cacheIsVip !== null) {
        return cacheIsVip === 'true' ? 'is-vip' : 'is-normal';
      }
      if (userStore.vipType === VipVasType.normal || !store.getters.isVip || !((_deviceStore$currentD7 = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD7 !== void 0 && (_deviceStore$currentD7 = _deviceStore$currentD7.deviceInfoRef.user) !== null && _deviceStore$currentD7 !== void 0 && (_deviceStore$currentD7 = _deviceStore$currentD7.vip) !== null && _deviceStore$currentD7 !== void 0 && _deviceStore$currentD7.is_vip)) {
        return 'is-normal';
      }
      return 'is-vip';
    });
    const nativeCallConfigNav = bodyClass => {
      const colorMap = {
        'is-dark': '#16181E',
        'is-normal': '#DFF1FF',
        'is-menu': '#FFFFFF',
        'is-vip': '#FEE8C5'
      };
      nativeCall('configNav', false, '迅雷下载', colorMap[bodyClass]);
      if (isAndroidNative) {
        sendMessage({
          platform: 'android',
          name: 'xlSetActionBar',
          params: {
            statusBarLightMode: val !== 'is-dark'
          }
        }, {
          noCallback: true
        });
      }
    };
    watch(bodyClass, val => {
      document.body.classList.remove('is-dark');
      document.body.classList.remove('is-normal');
      document.body.classList.remove('is-vip');
      document.body.classList.remove('is-menu');
      document.body.classList.add(val);
      nativeCallConfigNav(val);
    }, {
      immediate: true
    });
    const checkHezi = async () => {
      const deviceList = deviceStore.runnerList;
      if (!(deviceList !== null && deviceList !== void 0 && deviceList.length) || deviceList.filter(task => task.phase === 'PHASE_TYPE_RUNNING').length === 0) {
        // 没有在线设备的时候检查一下盒子在线状态
        // 测试环境不请求的原因是会把登录态踢掉
        if (store.getters.isLogin) {
          // 只检查一次
          try {
            // 没有找过盒子设备
            const heziStore = useHeziStore();
            await heziStore.getHezi();
            // haveLookUpHeziDevice = true
            // 取消主动跳转到盒子
            // if (Number(heziStore.heziDeviceList.length) > 0) {
            //   const firstHeziDevice = heziStore.heziDeviceList[0]
            //   heziStore.jumpToHezi(firstHeziDevice.id)
            // }
          } catch (e) {
            console.error('getHeziDeviceList error', e);
          }
        }
      }
    };
    const startRunner = async () => {
      var _deviceStore$currentD8;
      await deviceStore.pollRunnerList(12);
      const defaultSpace = selectDefaultDeviceSpace();
      if (defaultSpace) {
        deviceStore.changeCurrentDevice(defaultSpace);
      }
      setLocalValue('curDeviceRunner', (_deviceStore$currentD8 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD8 === void 0 ? void 0 : _deviceStore$currentD8.runnerTaskRef);
      watchDeviceExceedLimit(); //TODO: 测试设备数超出限制逻辑
      store.commit('update', {
        haveRequestedRunner: true
      });
      nextTick(() => {
        store.dispatch('getTasks');
      });
      window.deviceStore = deviceStore;
      if (isInXunleiApp() || envStore.isInPC || envStore.isInMac) {
        checkHezi();
      }
    };
    /**
     * 处理url中传入参数的不同行为
     */
    const handleQueryAction = async query => {
      if (query.nfo_id) {
        openPopCinemaDetail({
          nfo: {
            scrape_result: {
              id: Number(query.nfo_id)
            }
          },
          from: 'url_redirect'
        });
        return;
      }
      if (query.pop === 'source-setting') {
        openCinemaSourceSetting({
          from: 'url_redirect'
        });
        return;
      }
      if (query.pop === 'device-list') {
        var _router$currentRoute$2;
        const isLogin = await safeSSOInit();
        if (!isLogin) return;
        // 去掉pop参数
        router.push({
          name: (_router$currentRoute$2 = router.currentRoute.value.name) !== null && _router$currentRoute$2 !== void 0 ? _router$currentRoute$2 : 'home',
          query: {
            ...router.currentRoute.value.query,
            pop: ''
          }
        });
        setTimeout(() => {
          openDeviceList({
            actionFrom: 'url_action'
          });
        }, 500);
        return;
      }
    };
    const checkIsBindAndIsLogin = async () => {
      try {
        const {
          pathEnv
        } = useEnvStore();
        let authResult = {};
        if (STAND_AUTH_PROCESS_PATH_ENV.includes(pathEnv)) {
          // 如果厂商提供了H5直接调用到套件的穿透接口(如华为)，可以选择走下面的 auth 流程来处理绑定的流程。
          const {
            auth
          } = useAuth();
          const [isDeviceLogin, result] = await auth();
          authResult = result;
          console.log('isDeviceLogin, authResult', isDeviceLogin, authResult);
        }
        const query = {
          ...authResult,
          ...router.currentRoute.value.query
        };
        handleQueryAction(query);
        let isChanged = false;
        // user_code, client_id是从账号页面登录成功跳转回来时会带上的参数
        const isBind = (query === null || query === void 0 ? void 0 : query.user_code) && (query === null || query === void 0 ? void 0 : query.client_id); // 进入绑定
        const isLogin = await store.dispatch('login', {
          checkRunner: !isBind
        });
        console.log('isBind', isBind);
        if (!isLogin) {
          if ((query === null || query === void 0 ? void 0 : query.auto_login) === '1') {
            await sso.signIn();
            return;
          }
          if (!['/close', '/oauth-callback'].includes(router.currentRoute.value.path)) {
            router.replace({
              path: '/login',
              query: {
                ...query,
                ...authResult
              }
            });
          }
        } else {
          // Why?
          if (query.scope) {
            query.code && delete query.code;
            query.scope && delete query.scope;
            query.expires_in && delete query.expires_in;
            query.state && delete query.state;
            isChanged = true;
          }
          if (isBind) {
            query.user_code = query.user_code.replace(/\#\//, '');
            const newQueryAuth = Object.assign({}, queryAuth.value, {
              user_code: query.user_code,
              client_id: query.client_id
            });
            store.commit('update', {
              queryAuth: newQueryAuth
            });
            delete query.user_code;
            delete query.client_id;
            isChanged = true;
            bindDevice(newQueryAuth);
          } else {
            // 登录成功
            // 如果走绑定流程，会在getRunner之后开始请求
            setTimeout(async () => {
              // await store.dispatch('getDeviceInfoWatch')
              stat({
                action: 'connect_success_page_show'
              });
            }, 2000);
            // await store.dispatch('checkPrivilegeAuth')
            const envStore = useEnvStore();
            if (envStore.userID && envStore.userID !== global.userId) {
              var _authResult;
              store.commit('update', {
                deleteCompletely: false
              });
              const State = store.state;
              const user = State.Users.all[query.user_id] || {};
              const name = ((_authResult = authResult) === null || _authResult === void 0 ? void 0 : _authResult.name) || query.nickname || user.nickName || '';
              // const userID = (authResult as API_DEVICE.UserInfo)?.id || global.user_id || query.user_id || ''
              // logout2 为要求退出登陆，区分action以避免在个人页面中的退出两遍
              store.commit('dialog', {
                show: true,
                title: isNative.value ? '登录状态提示' : '登录失败',
                tip: `当前设备已经登录其他迅雷帐号，账号昵称【${name}】，您可以切换为该迅雷帐号进行下载管理（退出当前帐号后登录该帐号）`,
                okTxt: '切换帐号',
                cancelTxt: '',
                action: 'logout2',
                cancel: 'logout2'
              });
            } else {
              startRunner();
            }
          }
          // 去掉多余参数
          // TODO: 这种方式会导致返回时会恢复这些参数
          isChanged && setTimeout(() => window.history.replaceState(null, '', stringifySearch(query)), 1000);
        }
      } catch (e) {
        console.error(e);
      }
    };
    const bindDevice = async queryAuth => {
      const data = await store.dispatch('deviceAuthorize', {
        ...queryAuth,
        state: 'WAITING_CONSENT'
      });
      console.log(data);
      if (data && data.browser) {
        let name = '';
        if (!isAndroidNative && !isIOSNative) {
          var _await$getSSOUser$nic;
          name = (_await$getSSOUser$nic = (await getSSOUser()).nickName) !== null && _await$getSSOUser$nic !== void 0 ? _await$getSSOUser$nic : ''; // 取了个nickname
        } else {
          var _store$state$user$nic, _store$state;
          name = (_store$state$user$nic = (_store$state = store.state) === null || _store$state === void 0 || (_store$state = _store$state.user) === null || _store$state === void 0 ? void 0 : _store$state.nickName) !== null && _store$state$user$nic !== void 0 ? _store$state$user$nic : '';
        }
        store.commit('dialog', {
          show: true,
          title: '确定登录',
          tip: `账号【${name}】即将登录${data.address}的${DEVICE_NAME_MAP.get(data.browser) || ''}设备`,
          okTxt: '确定',
          cancelTxt: '取消',
          action: 'authOk',
          cancel: 'authCancel',
          showLoader: true
        });
      } else {
        if ((data === null || data === void 0 ? void 0 : data.error_description) === 'risk account') {
          store.commit('dialog', {
            show: true,
            title: '登录失败',
            tip: '账号存在风险，登录授权失败，请前往迅雷个人中心（i.xunlei.com）自助解封',
            okTxt: '确定并退出',
            action: 'close'
          });
        } else {
          store.commit('dialog', {
            show: true,
            title: '登录超时',
            tip: '迅雷登录授权已过期，请退出迅雷后重新打开',
            okTxt: '确定并退出',
            action: 'close'
          });
        }
      }
    };
    const handleAuth = async () => {
      var _router$currentRoute$3;
      const data = await store.dispatch('deviceAuthorize', {
        ...queryAuth.value,
        state: 'ACCOMPLISHED'
      });
      store.commit('dialog', {
        show: false
      });
      if (((_router$currentRoute$3 = router.currentRoute.value.query) === null || _router$currentRoute$3 === void 0 ? void 0 : _router$currentRoute$3.privilege) === 'PAN_CLI_PREVIEW') {
        handleCheck();
      } else {
        handleRunner();
      }
      store.commit('dialog', {
        show: false,
        action: '',
        cancel: '',
        showLoader: false
      });
    };
    const handleCheck = async () => {
      await store.dispatch('checkPrivilegeAuth');
      if (privilegeAuth.value) {
        handleRunner();
      } else {
        store.commit('dialog', {
          show: false,
          cancelTxt: ''
        });
        setTimeout(() => {
          store.commit('dialog', {
            show: true,
            title: '请在NAS设备输入内测邀请码',
            tip: '该版本仅为Beta版不代表最终上线品质，目前采用邀请制，拥有内测邀请码才可以参与内测',
            okTxt: '确认',
            action: 'check',
            showLoader: false
          });
          store.commit('update', {
            showLoader: false
          });
        }, 1000);
      }
    };
    const handleRunner = async () => {
      setTimeout(async () => {
        // H5主界面展示(用户有登录NAS且绑定设备后才上报)
        stat({
          action: 'mobile_homepage_show'
        });
        const {
          pathEnv
        } = useEnvStore();
        if (STAND_AUTH_PROCESS_PATH_ENV.includes(pathEnv)) {
          const {
            updateAuthStatus
          } = useAuth();
          await updateAuthStatus();
        }
        const envStore = useEnvStore();
        if (!envStore.hasPopDeviceLimitExceededShown && global.error_message === '超过同时登录设备上限') {
          envStore.hasPopDeviceLimitExceededShown = true;
          openDialogDeviceLimitExceeded({});
        }
        store.commit('Devices/set', global.fromSpace);
        startRunner();
        // setTimeout(() => store.dispatch('getDeviceInfoWatch'), 2000)
      }, 3000);
    };
    const handleAuthCancel = async () => {
      store.commit('dialog', {
        show: false,
        tip: '',
        more: ''
      });
      await store.dispatch('deviceAuthorize', {
        ...queryAuth.value,
        state: 'ACCESS_DENIED'
      });
      store.dispatch('logout', true);
    };
    watch(action, val => {
      if (val === 'authOk') handleAuth();else if (val === 'authCancel') handleAuthCancel();else if (val === 'logout2' || val === 'close') {
        if (isNative.value) {
          store.dispatch('close');
        } else {
          store.dispatch('logout', true);
        }
      } else if (val === 'check') store.commit('dialog', {
        show: false
      });
    });
    watch(target, val => {
      if (val && router.currentRoute.value.name !== 'login') {
        flowHubInstance.getFlowHubSlots('POSITION_CINEMA_EMPTY');
      }
    });
    const needExtraHeaderPadding = () => {
      if (isAndroidNative) {
        return true;
      }
      return false;
    };
    let isPageShowEventListenerAttached = false;
    onBeforeMount(() => {
      if (!isPageShowEventListenerAttached) {
        // 因为safari浏览器上有page cache，后退的时候不会触发onload事件，所以需要监听pageshow事件，重新设置nav
        window.addEventListener('pageshow', () => {
          nativeCallConfigNav(bodyClass.value);
        });
        isPageShowEventListenerAttached = true;
      }
    });
    onMounted(async () => {
      checkIsBindAndIsLogin();
      await userStore.getUser();
      setLocalValue('isVip', userStore.isVip);
      if (needExtraHeaderPadding()) {
        document.body.classList.add('is-extra-header-padding');
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createVNode(Header, null, null, 512), [[_vShow, showHead.value]]), _createVNode(_unref(RouterView), {
        "keep-alive": ""
      }), _createVNode(FooterBar), _createVNode(FilePop), _withDirectives(_createVNode(Dialog, null, null, 512), [[_vShow, show.value]]), _createVNode(HuddlePop), _withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(toast.value.message), 1)], 512), [[_vShow, toast.value.message]])], 64);
    };
  }
});